import Vue from 'vue'
import { LOGIN, LOGIN_RFID, LOGOUT, SET_APP_FEATURES } from './actionsTypes'
import { SET_AUTH, RESET_AUTH, SET_PERMISSIONS, RESET_PERMISSIONS } from './mutationsTypes'
import cookie from 'vue-cookie'
import { hostAppApi } from '@/plugins/axios_settings'

const state = {
  isAuthenticated: false,
  authToken: null,
  userDetails: {},
  role: {},
  permissions: {}
}

const getters = {
  userDetails (state) {
    return state.userDetails
  },
  getuserDetails (state) {
    return state.userDetails
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  }
}

const loginAction = (context, url, payload, tenant) =>
  new Promise((resolve, reject) => {
    hostAppApi.post(url, payload)
      .then((response) => {
        if (!(response && response.data)) {
          reject(new Error('message.login.authFailed'))
        }
        if (response.data.status !== 'success') {
          reject(new Error(response.data[`${this.$i18n.locale}_message`] || response.data.message))
        }

        const date = new Date()
        date.setDate(date.getDate() + 4)

        const permissions = { permissions: response.data.permissions || {}, role: response.data.role || {} }
        const user = {
          id: response.data.user.user_id,
          name: `${response.data.user.first_name} ${response.data.user.last_name}`,
          email: response.data.user.email,
          role_id: response.data.role.id,
          initialer: response.data.user.initialer
        }

        cookie.set(process.env.VUE_APP_HOST_USER, response.data.user.user_id, { expires: date })
        cookie.set(process.env.VUE_APP_HOST_TOKEN, response.data.token, { expires: date })
        cookie.set(process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN, response.data.checklist_access_token, { expires: date })
        cookie.set(process.env.VUE_APP_PERMISSIONS_AND_ROLES, Vue.prototype.$formatter.encryptString(JSON.stringify(permissions)), { expires: date })
        cookie.set(process.env.VUE_APP_TOKEN, response.data.token, { expires: date })
        cookie.set(process.env.VUE_APP_USER, JSON.stringify(user), { expires: date })
        cookie.set('WelditPwa_host-ref', tenant, { expires: date.getDate() + 26 })

        window.localStorage.setItem(process.env.VUE_APP_TASKS_COUNT, response.data.task_count || 0)
        window.localStorage.setItem(process.env.VUE_APP_DOMAIN_CACHE_NAME, tenant)

        context.commit(SET_AUTH, { authToken: response.data.token, user: user })
        context.commit(SET_PERMISSIONS, permissions)

        resolve({
          redirectTo: {
            1: '/calendar',
            2: '/stemp',
            3: '/dashboard'
          }[response.data.redirect_to]
        })
      })
      .catch(() => {
        reject(new Error('message.login.authFailed'))
      })
  })

const actions = {
  [LOGIN] (context, { host, tenant, email, password }) {
    return loginAction(context, `https://${host}/api/login`, { email, password }, tenant)
  },
  [LOGIN_RFID] (context, { host, tenant, rfid }) {
    return loginAction(context, `https://${host}/api/loginrfid`, { rfidnumber: rfid }, tenant)
  },
  [SET_APP_FEATURES] ({ state: { userDetails } }, { host }) {
    return new Promise((resolve, reject) => {
      hostAppApi.get(`https://${host}/api/check_and_get_tenant_features`)
        .then((response) => {
          if (!(response && response.data && response.data.features)) {
            reject(new Error('message.login.fetchAppFeaturesFailed'))
          }
          window.localStorage.setItem(process.env.VUE_APP_FEATURES_LIST, Vue.prototype.$formatter.encryptString(JSON.stringify(response.data.features)))

          resolve()
        })
        .catch(() => {
          reject(new Error('message.login.fetchAppFeaturesFailed'))
        })
    })
  },
  [LOGOUT] ({ commit }) {
    cookie.delete(process.env.VUE_APP_HOST_USER)
    cookie.delete(process.env.VUE_APP_HOST_TOKEN)
    cookie.delete(process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN)
    cookie.delete(process.env.VUE_APP_PERMISSIONS_AND_ROLES)
    cookie.delete(process.env.VUE_APP_TOKEN)
    cookie.delete(process.env.VUE_APP_USER)
    cookie.delete('WelditPwa_host-ref')

    window.localStorage.removeItem(process.env.VUE_APP_TASKS_COUNT)
    window.localStorage.removeItem(process.env.VUE_APP_FEATURES_LIST)

    commit(RESET_AUTH)
    commit(RESET_PERMISSIONS)
  }
}

const mutations = {
  [SET_AUTH] (state, user) {
    state.isAuthenticated = true
    state.authToken = user.authToken
    state.userDetails = user.user
  },
  [RESET_AUTH] (state) {
    state.isAuthenticated = false
    state.authToken = null
    state.userDetails = {}
  },
  [SET_PERMISSIONS] (state, obj) {
    state.permissions = obj.permissions || {}
    state.role = obj.role || {}
  },
  [RESET_PERMISSIONS] (state) {
    state.permissions = {}
    state.role = {}
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
